import axios from "axios"

interface VerifyOtpData {
    otp: string
    email?: string
    phone?: string
    callingCode?: string
}

export const verifyOtp = async (data: VerifyOtpData) => {
    const response = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}users/verify`,
        data,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    )
    return response.data
}
